var CustomSelect = require("../../components/customSelect");

/*
 * Address Book
 */
document.addEventListener("DOMContentLoaded", () => {
	if ($("#address-book-table").length) {
		// Pagination labels (set in Blade template)
		const labels = window.pagination_labels || {
			'first': 'First',
			'previous': 'Previous',
			'next': 'Next',
			'last': 'Last',
			'rows_per_page': 'rows per page'
		};

		// Custom filter for DataTables
		$.fn.dataTable.ext.search.push(
			function(settings, data, dataIndex) {
				// Only apply to address book table
				if (settings.nTable.id !== 'address-book-table') {
					return true;
				}

				const searchText = $('#search_address_book').val().toLowerCase();
				if (!searchText) {
					return true;
				}

				// Search in surname (column 0) and name (column 1)
				const surname = data[0].toLowerCase();
				const name = data[1].toLowerCase();

				return surname.includes(searchText) || name.includes(searchText);
			}
		);

		// Initialize DataTable
		var addressBookTable = $('#address-book-table').DataTable({
			bAutoWidth: false,
			order: [[0, 'asc']], // Order by surname
			dom: 't', // Only table, footer will be custom
			pageLength: 10,
			drawCallback: function(settings) {
				updateFooterControls(this.api());
			}
		});

		// Search functionality
		$('#search_address_book').on('keyup', function() {
			addressBookTable.draw();
		});

		// Function to render footer controls
		function updateFooterControls(api) {
			const info = api.page.info();
			const $footer = $('#address-book-table-footer');

			// Build pagination HTML
			let paginationHtml = '<div class="custom-pagination">';

			// First button
			if (info.page > 0) {
				paginationHtml += '<a class="page-btn page-first" data-page="0">' + labels.first + '</a>';
			} else {
				paginationHtml += '<a class="page-btn page-first disabled">' + labels.first + '</a>';
			}

			// Previous button
			if (info.page > 0) {
				paginationHtml += '<a class="page-btn page-prev" data-page="' + (info.page - 1) + '">' + labels.previous + '</a>';
			} else {
				paginationHtml += '<a class="page-btn page-prev disabled">' + labels.previous + '</a>';
			}

			// Page numbers
			const totalPages = info.pages;
			const currentPage = info.page;
			let startPage = Math.max(0, currentPage - 2);
			let endPage = Math.min(totalPages - 1, currentPage + 2);

			for (let i = startPage; i <= endPage; i++) {
				if (i === currentPage) {
					paginationHtml += '<span class="page-btn current">' + (i + 1) + '</span>';
				} else {
					paginationHtml += '<a class="page-btn page-num" data-page="' + i + '">' + (i + 1) + '</a>';
				}
			}

			// Next button
			if (info.page < info.pages - 1) {
				paginationHtml += '<a class="page-btn page-next" data-page="' + (info.page + 1) + '">' + labels.next + '</a>';
			} else {
				paginationHtml += '<a class="page-btn page-next disabled">' + labels.next + '</a>';
			}

			// Last button
			if (info.page < info.pages - 1) {
				paginationHtml += '<a class="page-btn page-last" data-page="' + (info.pages - 1) + '">' + labels.last + '</a>';
			} else {
				paginationHtml += '<a class="page-btn page-last disabled">' + labels.last + '</a>';
			}

			paginationHtml += '</div>';

			// Build info HTML
			const infoHtml = '<div class="table-info">' + (info.start + 1) + '-' + info.end + ' of ' + info.recordsDisplay + '</div>';

			// Build page length selector HTML
			const pageLengthHtml = '<div class="dataTables_length">' +
				'<select id="address-book-length-select" class="sld-select--no-border">' +
				'<option value="10"' + (info.length === 10 ? ' selected' : '') + '>10</option>' +
				'<option value="25"' + (info.length === 25 ? ' selected' : '') + '>25</option>' +
				'<option value="50"' + (info.length === 50 ? ' selected' : '') + '>50</option>' +
				'<option value="100"' + (info.length === 100 ? ' selected' : '') + '>100</option>' +
				'</select>' +
				'<div class="select-label">' + labels.rows_per_page + '</div>' +
				'</div>';

			// Clear and rebuild footer
			$footer.empty();
			$footer.append(infoHtml);
			$footer.append(paginationHtml);
			$footer.append(pageLengthHtml);

			// Attach pagination click handlers
			$footer.find('.page-btn:not(.disabled):not(.current)').off('click').on('click', function(e) {
				e.preventDefault();
				const page = $(this).data('page');
				if (page !== undefined && page !== null) {
					addressBookTable.page(page).draw('page');
				}
			});

			// Initialize custom select and attach change handler
			if (typeof CustomSelect !== 'undefined') {
				var page_length_custom_select = new CustomSelect("#address-book-length-select");
				page_length_custom_select.$sld_select.on("select_option", function () {
					addressBookTable.page.len(page_length_custom_select.getSelectedValue()).draw();
				});
			}
		}

		// Hide any auto-generated DataTables elements
		$('#address-book-table_wrapper .dataTables_filter, #address-book-table_wrapper .dataTables_info, #address-book-table_wrapper .dataTables_paginate').hide();

		// Initial footer render
		updateFooterControls(addressBookTable);
	}
});
